import { combineClass, type JSX } from 'cdui-js';
import './UnderlineItem.css';
import type { DiFiCheckBoxItemProps } from './types';
import { bindActivate, resolveLabel, rootA11y } from './shared';

function underlineThemeVars(defaultColor?: string, activeColor?: string): JSX.CSSProperties {
  const v: Record<string, string> = {};
  if (defaultColor) v['--difi-cb-uline'] = defaultColor;
  if (activeColor) {
    v['--difi-cb-uline-active'] = activeColor;
    v['--difi-cb-uline-active-text'] = activeColor;
  }
  return v as JSX.CSSProperties;
}

/** 下划线多选 */
export const UnderlineItem = (props: DiFiCheckBoxItemProps) => {
  const activate = bindActivate(props.itemProps);
  const a11y = rootA11y(props.itemProps);
  const rootStyle: JSX.CSSProperties = {
    ...underlineThemeVars(props.itemProps.defaultColor, props.itemProps.activeColor),
    ...props.itemProps.style,
  };

  return (
    <div
      class={combineClass(
        'difi-checkbox-underline',
        props.itemProps.checked === true && 'difi-checkbox-underline--active',
        props.itemProps.disabled === true && 'difi-checkbox-underline--disabled',
        props.itemProps.class,
      )}
      style={rootStyle}
      {...a11y}
      {...activate}
    >
      {resolveLabel(props.itemProps, 'difi-checkbox-underline__label', true)}
    </div>
  );
};
